export type AbsoluteHttpUrlOptions = {
  allowEmpty?: boolean
  allowHash?: boolean
}

export function isAbsoluteHttpUrl(value: string, options: AbsoluteHttpUrlOptions = {}) {
  const trimmed = value.trim()
  if (trimmed.length === 0) return options.allowEmpty === true

  try {
    const parsed = new URL(trimmed)
    const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:'
    const isHashAllowed = options.allowHash === true || parsed.hash.length === 0
    return isHttp && isHashAllowed
  } catch {
    return false
  }
}

export function isHttpsRedirectUrl(
  value: string,
  previous?: string,
  options: AbsoluteHttpUrlOptions = {},
) {
  if (!isAbsoluteHttpUrl(value, options)) return false
  const trimmed = value.trim()
  return (
    trimmed === '' ||
    new URL(trimmed).protocol === 'https:' ||
    (previous !== undefined && trimmed === previous.trim())
  )
}
